import { render, staticRenderFns } from "./OtpScreen.vue?vue&type=template&id=549cd583&scoped=true"
import script from "./OtpScreen.vue?vue&type=script&lang=js"
export * from "./OtpScreen.vue?vue&type=script&lang=js"
import style0 from "./OtpScreen.vue?vue&type=style&index=0&id=549cd583&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549cd583",
  null
  
)

export default component.exports